<template lang="html">
  <div :class="MainAuth.main">
    <div :class="$style.authbox">
      <div class="form" v-loading="loading" id="boxauth">
        <span v-if="!google2fa">
          <h1 :class="$style.texth1">
          Bem-vindo à <span class="text-primary">Plataforma de Gestão</span>.
        </h1>
        <br />
        <p class="mb-2">Preencha os dados abaixo para entrar.</p>
        <el-form
            status-icon
            :model="ruleForm"
            size="medium"
            ref="ruleForm"
            :rules="rules"
            @submit.prevent
            v-on:submit.prevent
        >
          <el-form-item prop="email" label="Email" :error="error.email">
            <el-input
                :autofocus="true"
                size="large"
                v-model="ruleForm.email"
                placeholder="example@gmail.com"
                type="email"
                required
            ></el-input>
          </el-form-item>
          <el-form-item prop="password" label="Senha" :error="error.password">
            <el-input
                size="large"
                placeholder="● ● ● ● ● ●"
                v-model="ruleForm.password"
                :type="type"
                required
            >
              <i class="el-icon-view el-input__icon" slot="suffix" @click="changeType">
              </i>
            </el-input>

            <el-button type="text">
              <router-link class="link-text" :to="{ name: 'auth.forgotPassword' }"
              >Esqueci minha senha.</router-link
              >
            </el-button>
            <br />
            <el-button type="text">
              <span class="link-text" style="text-decoration: underline;" @click="openWhatsApp">
                Problemas ao fazer login?.
              </span>
            </el-button>
          </el-form-item>
          <el-form-item style="margin: 0"> </el-form-item>
          <el-button
              size="large"
              class="raise-primary"
              type="primary"
              native-type="submit"
              @click.prevent="submitLogin('ruleForm')"
          >Entrar</el-button
          >
        </el-form>
        </span>
        <span v-else>
          <h1 :class="$style.texth1b">Habilite a autenticação de 2 fatores</h1>
          <br>
          <p class="mb-2" style="line-height: 20px;">
            <span style="font-weight: bold;"> 1. </span>
            Abra o aplicativo do Google Authenticator em seu dispositivo
            <br>
            <span style="font-weight: bold;"> 2. </span>
            Clique no botão <span style="font-weight: bold;">"+"</span> e leia o QR Code com o autenticador
            e digite o código gerado para habilitar a autenticação.
            <br>
          </p>
          <div :class="$style.boxTime">
            {{countDown}}
          </div>
          <div style="display: flex; justify-content: center;" v-html="qrcode">
          </div>

          <div style="display: flex; justify-content: center;">
            <PincodeInput
                v-model="code"
                placeholder=""
                :length="digito"
            />
          </div>
          <el-button
              @click="submitCod"
              style="width: 100%; margin-top: 20px; margin-left: 0;"
              class="raise-success"
              type="success"
          >
            Enviar
          </el-button>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { postLogin } from "../../services";
import MainAuth from "../MainAuth.scss?module";
import { makeErrorFilds, setFormData } from "@/app/plugins/utils";
import {mapActions, mapGetters} from "vuex";
import {postGenerateCodeGoogle2FA, postLogin2FA} from "@/app/domains/Auth/services";
import PincodeInput from 'vue-pincode-input';
import localstorage from "@/app/plugins/localstorage";
import {app} from "../../../../config";

export default {
  name: "Login",
  components: {
    PincodeInput
  },
  data() {
    return {
      loading: false,
      type: "password",
      google2fa: false,
      google2fasecret: '',
      digito: 6,
      countDown: 300,
      isSend: true,
      qrcode: '',
      code: '',
      error: {},
      ruleForm: {
        email: "",
        password: "",
      },
      accounts: {},
      rules: {
        email: [
          { required: true, message: "Por favor informe um e-mail", trigger: "blur" },
          {
            type: "email",
            message: "Por favor informe um e-mail valido",
            trigger: "blur",
          },
        ],
        password: [{ required: true, message: "Digite sua Senha!", trigger: "blur" }],
      },
    };
  },
  watch: {
    'code': function (pa) {
      if (pa.length === this.digito) {
        this.isSend = false
      } else {
        this.isSend = true
      }
    }
  },
  computed: {
    MainAuth() {
      return MainAuth;
    },
    ...mapGetters('Auth', ['currentUser', 'getGSK']),
  },
  methods: {
    ...mapActions("Auth", ["loadUser"]),
    async logarSystem(permission, resUser) {
      this.$store.commit("Auth/SET_CURRENT_PERMISSION", [String(permission)]);
      this.$store.commit("Auth/SET_USER", resUser);
      await this.loadUser();
      if (this.currentUser.type_account_id === 1 || this.currentUser.type_account_id === 2 || this.currentUser.type_account_id === 4 || this.currentUser.type_account_id === 6) {
        if (this.currentUser.type_two_factor === 'google2fa') {
          if (!this.currentUser.google_secret_key) {
            this.google2fa = true;
            this.countDownTimer();
            await this.submitGenerateCode();
          } else {
            await this.$router.push({name: 'auth.twofactor'})
          }
        } else {
          await this.$router.push({ name: "home2.index" });
        }
      } else if(this.currentUser.type_account_id === 2 || this.currentUser.type_account_id === 6) {
        await this.$router.push({ name: "home2.index" });
      } else {
        await this.$router.push({ name: "home.index" });
      }
    },
    async submitLogin(ruleForm) {
      this.loading = true;
      this.type = "password";
      this.$refs[ruleForm].validate(async (valid) => {
        if (valid) {
          this.error = {};
          try {
            let response = await postLogin(setFormData(this.ruleForm));
            this.$store.commit("Auth/SET_TOKEN", response.data.access_token);
            let responseUser = await this.loadUser();
            this.google2fasecret = response.data.user.google_secret_key;
            await this.$store.dispatch("Auth/setGSK", this.google2fasecret);

            let types = ["0", "Admin", "marketplace", "3", "agent", "department_store"];
            if (
              response.data.user.type_account_id !== 1 &&
              response.data.user.type_account_id !== 6
            ) {
              let host = "";
              if (response.data.user.type_account_id === 2) {
                host =
                  responseUser[types[response.data.user.type_account_id]].slug +
                  ".posportal.com.br";
              } else {
                host =
                  responseUser[types[response.data.user.type_account_id]].marketplace
                    .slug + ".posportal.com.br";
              }
              if (host === window.location.host) {
                this.logarSystem(response.data.user.type_account_id, responseUser);
              } else {
                if (
                  window.location.host === "localhost:8080" ||
                  window.location.host === "localhost:4501"
                ) {
                  this.logarSystem(response.data.user.type_account_id, responseUser);
                } else {
                  window.location.href =
                      `https://${host}?t=${response.data.access_token}&gsk=${this.google2fasecret}`
                }
              }
            } else {
              if (
                window.location.host.split(".")[0] === "www" ||
                window.location.host.split(".")[0] === "homolog" ||
                window.location.host === "localhost:8080" ||
                window.location.host === "localhost:8081" ||
                window.location.host === "localhost:4501"
              ) {
                this.logarSystem(response.data.user.type_account_id, responseUser);
              } else {
                window.location.href =
                  `https://posportal.com.br/?t=${response.data.access_token}&gsk=${this.google2fasecret}`;
              }
            }
          } catch (e) {
            this.error = makeErrorFilds(e);
            this.$message({
              showClose: true,
              message: makeErrorFilds(e)[Object.keys(makeErrorFilds(e))[0]],
              type: "error",
            });
          } finally {
            this.loading = false;
          }
        } else {
          this.loading = false;
        }
      });
    },
    async submitGenerateCode () {
      try {
        this.loading = true;
        let response = await postGenerateCodeGoogle2FA(this.currentUser.id, {
          password: this.ruleForm.password,
          gsk: this.getGSK ? this.getGSK : await localstorage.getItem(app.userGSKStorageKey),
        });
        this.qrcode = response.bodyText;
      } catch (e) {

        this.error = makeErrorFilds(e)
        this.$message({
          showClose: true,
          message: makeErrorFilds(e)[Object.keys(makeErrorFilds(e))[0]],
          type: 'error'
        })
      } finally {
        this.loading = false
      }
    },
    async submitCod () {
      try {
        let response = await postLogin2FA({
          token: this.code,
          gsk: this.getGSK ? this.getGSK : await localstorage.getItem(app.userGSKStorageKey)
        })
        this.$store.commit('Auth/SET_TOKEN', response.data.access_token)
        this.$store.commit('Auth/CLEAN_GOOGLE_SECRET_KEY');
        await this.$router.push({ name: "home2.index" });
      } catch (e) {
        if (e.body.data) {
          this.$message({
            showClose: true,
            message: e.body.data,
            type: 'error'
          });
        } else {
          this.error = makeErrorFilds(e)
          this.$message({
            showClose: true,
            message: makeErrorFilds(e)[Object.keys(makeErrorFilds(e))[0]],
            type: 'error'
          })
        }
      } finally {
        this.loading = false
      }
    },
    countDownTimer () {
      if (this.countDown > 0) {
        setTimeout(() => {
          this.countDown -= 1
          this.countDownTimer()
        }, 1000)
      } else {

        this.isBack = true
      }
    },
    // eslint-disable-next-line no-unused-vars
    changeType(ev) {
      if (this.type === "password") {
        this.type = "text";
      } else if (this.type === "text") {
        this.type = "password";
      }
    },
    openWhatsApp() {
      const url = "https://api.whatsapp.com/send/?phone=5511995974480&text&type=phone_number&app_absent=0";
      window.open(url, "_blank");
    },
  },
  async mounted() {

    if (this.$route.query.gsk !== undefined) {
      await this.$store.dispatch("Auth/setGSK", this.$route.query.gsk);
    }

    if (this.$route.query.t !== undefined) {
      const loading = this.$loading({ lock: true });
      try {
        this.$store.commit("Auth/SET_TOKEN", this.$route.query.t);
        let responseUser = await this.loadUser();

        this.logarSystem(responseUser.type_account_id, responseUser);
        // this.$store.commit('Auth/SET_CURRENT_PERMISSION', [String(responseUser.type_account_id)])
        // this.$store.commit('Auth/SET_USER', responseUser)
        //
        // await this.$router.push({name: 'home.index'})
      } catch (e) {
        this.error = makeErrorFilds(e);
        this.$message({
          showClose: true,
          message: makeErrorFilds(e)[Object.keys(makeErrorFilds(e))[0]],
          type: "error",
        });
      } finally {
        loading.close();
      }
    }
  },
};
</script>

<style lang="scss" module>
.boxTime {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 26px;
  font-weight: 900;
  color: #9ca3a6;
  padding: 15px;
}
.authbox {
  max-width: 450px;
  padding: 0 5.5em;
}
.texth1 {
  font-size: 2.5rem;
}
.texth1b {
  font-size:1.6rem;
}
@media (max-width: 800px) {
  .authbox {
    max-width: 100%;
    padding: 0 1.5em;
  }
}
</style>
